<template>
  <div>
    <div class="header">
      <img src="\Images\Image.png" alt="The Universal Insurance Company Limited Logo">
      <div class="header-text">
        <div class="title">The Universal Insurance Company Limited</div>
        <div class="subtitle">Know Your Customer (KYC) / Customer Due Diligence (CDD) Form</div>
        <div class="individual">( Individual Customers )</div>
      </div>
    </div>

    <div class="date-line">
      Date: <span class="input-line"></span>
    </div>

    <div class="customer-info">
      <div>
        Customer Name: <span class="input-line">{{ item.BP_DSC }}</span>
        <div style="font-size: 9pt;">As per CNIC</div>
      </div>
      <div>
        Branch Code: <span class="input-line">{{ item.BRANCH_ID }}</span>
      </div>
    </div>

    <div class="customer-info">
      <div>
        Permanent Address <span class="input-line">{{ item.BP_ADDRESS }}</span>
        <div style="font-size: 9pt;">As per CNIC</div>
      </div>
      <div>
        Client Code: <span class="input-line">{{ item.BP_CODE_NEW }}</span>
      </div>
    </div>

    <div class="form-section" style="page-break-after: always">
      <div class="section-title">Personal Information/ Detail</div>

      <div class="form-row">
        Current Address (if different from CNIC) <span class="input-line">{{ item.BP_ADDRESS }}</span>
      </div>

      <div class="form-row">
        <div class="form-field">
          Father/ Husband's Name: <span class="input-line">{{ item.BP_FATHER_HUSBANDNAME }}</span>
        </div>
        <div class="form-field">
          Mother's Maiden Name: <span class="input-line">{{ item.BP_MOTHERNAME }}</span>
        </div>
        <div class="form-field">
          Gender:
          Male <span class="checkbox">{{ item.BP_IFINDVGENDER === 'M' ? '✔' : '' }}</span>
          Female <span class="checkbox">{{ item.BP_IFINDVGENDER === 'F' ? '✔' : '' }}</span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          Landline No. <span class="input-line">{{ item.LANDLINE }}</span>
        </div>
        <div class="form-field">
          Cell No. <span class="input-line">{{ item.BP_MOBILE }}</span>
        </div>
        <div class="form-field">
          Email ID: <span class="input-line">{{ item.BP_EMAIL_ADDRESS }}</span>
        </div>
        <div class="form-field">
          NTN No. <span class="input-line">{{ item.BP_NTN_NO }}</span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          Income Tax Status: Filer <span class="checkbox">{{ item.BP_ISACTTAXPAY === '1' ? '✔' : '' }}</span> Non Filer <span class="checkbox">{{ item.BP_ISACTTAXPAY === '0' ? '✔' : '' }}</span>
        </div>
        <div class="form-field">
          Nationality: Pakistan <span class="checkbox"></span> Other <span class="input-line"></span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          Date of Birth: <span class="input-line">{{ item.BP_DOB }}</span>
        </div>
        <div class="form-field">
          Place of Birth: <span class="input-line">{{ item.BP_PLACEOFBIRTH }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          Resident: <span class="checkbox">{{ item.BP_ISRESEDENT === '1' ? '✔' : '' }}</span> Non Resident <span class="checkbox">{{ item.BP_ISRESEDENT === '0' ? '✔' : '' }}</span> Foreign National <span class="checkbox">{{ item.BP_ISRESEDENT === 'Foreign National' ? '✔' : '' }}</span>
        </div>
        <div class="form-field">
          CNIC/NICOP/Passport No. <span class="input-line">{{ item.BP_NIC_NO || item.BP_PASSPORTNO }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          Verification: Yes <span class="checkbox">{{ item.BP_CNICVARIFICATINO === 'Y' ? '✔' : '' }}</span> No <span class="checkbox">{{ item.BP_CNICVARIFICATINO === 'N' ? '✔' : '' }}</span>
        </div>
        <div class="form-field">
          CNIC/Passport Issue date: <span class="input-line">{{ item.BP_CNICISSUEDATE }}</span>
        </div>
        <div class="form-field">
          CNIC/Passport Expiry date: <span class="input-line">{{ item.BP_CNIC_EXPIRYDATE }}</span>
        </div>
      </div>

      <div class="form-row">
        Source of Income: Salary <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Salary' ? '✔' : '' }}</span> Business Income <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Business Income' ? '✔' : '' }}</span> Foreign Remittance <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Foreign Remittance' ? '✔' : '' }}</span> Investment Income <span class="checkbox">{{ item.BP_SOURCEOFINCOME === 'Investment Income' ? '✔' : '' }}</span> Other (Specify) <span class="input-line">{{ item.BP_SOURCEOFINCOME_SPFY }}</span>
      </div>

      <div class="form-row">
        <div class="form-field">
          Purpose and intended nature of Business Relationship with UIVIC: <span class="input-line"></span>
        </div>
        <div class="form-field">
          Type of Account/Financial Transaction/Financial Services: <span class="input-line"></span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          Expected monthly turnover (amount & No. of transaction): <span class="input-line"></span>
        </div>
        <div class="form-field">
          Normal or expected modes of Transactions/Delivery Channels: <span class="input-line"></span>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          Business Name: <span class="input-line">{{ item.BP_BUSINESSNAME }}</span>
        </div>
        <div class="form-field">
          Business Address: <span class="input-line">{{ item.BP_BUSINESSADDRESS }}</span>
        </div>
      </div>

      <div class="form-row">
        Main Geographically area of activity: Within Pakistan (Specify) <span class="input-line">{{ item.BP_MAINGAOAWITHINPAK }}</span>
      </div>

      <div class="form-row">
        Outside Pakistan (Specify): <span class="input-line">{{ item.BP_OUTSIDEPAKACTIVITY }}</span>
      </div>

      <div class="form-row">
        <div class="form-field">
          Politically Exposed Person (PEP): No <span class="checkbox">{{ item.BP_PEP === 'No' ? '✔' : '' }}</span> Yes <span class="checkbox">{{ item.BP_PEP === 'Yes' ? '✔' : '' }}</span>
        </div>
        <div class="form-field">
          if yes, Domestic PEP: <span class="checkbox">{{ item.BP_DOMESTICPEP === 'DOM' ? '✔' : '' }}</span> Foreign PEP <span class="checkbox">{{ item.BP_DOMESTICPEP === 'FOR' ? '✔' : '' }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          if Yes, Self: Position/Status <span class="input-line">{{ item.BP_IFPEPPOSITIONSTATUS }}</span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-field">
          if yes, by way of family member/close associates: <span class="input-line">{{ item.BP_IFPEPBYWAOFACC_RELATION }}</span> Position held: <span class="input-line">{{ item.BP_POSITIONHELD }}</span>
        </div>
      </div>

      <div style="text-align: center; font-size: 10pt;">(State Relationship)</div>
    </div>

    <div class="form-section">
      <div class="section-title">Declaration</div>

      <div class="declaration">
        1. I confirm that the information given in this form is true, complete and accurate to the best of my knowledge and belief and further I undertake that any
        change in this regard will be duly communicated to the Company for updation of their records, failing which, I will indemnify the Company for any loss
        resulting from my failure to honor the afore-stated undertaking.
      </div>

      <div class="declaration">
        2. I hereby give my irrevocable and unconditional consent to The Universal Insurance Company Limited to verify, as and when required, at the sole
        discretion of the Company, my CNIC from NADRA and other details furnished by me from relevant regulators.
      </div>

      <div class="signature-line">
        <div class="signature">
          <div class="signature-box"></div>
          Customer Signature
        </div>
        <div class="signature">
          <div class="signature-box"></div>
          Relationship Manager - The Universal Insurance Co. Ltd.
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">To be filled by Marketing Staff</div>

      <div style="text-align: center; margin-bottom: 20px;">
        I have checked this KYC form and the required documents and certify that these are in order.
      </div>

      <div class="signature-line">
        <div class="signature">
          Sign / Date: <span class="input-line"></span>
          <div style="margin-top: 10px;">Field Officer</div>
        </div>
        <div class="signature">
          Sign / Date: <span class="input-line"></span>
          <div style="margin-top: 10px;">Branch Head</div>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">Documents Required</div>

      <ol>
        <li>Photocopy of CNIC/ NICOP.</li>
        <li>For Foreign National copy of Passport having valid visa on it or any other proof of legal stay alongwith passport copy.</li>
        <li>For a salaried person, in addition to CNIC, a copy of his/ her salary slip or service card or certificate or letter on letter head of the employer.</li>
      </ol>
    </div>

    <div class="form-section">
      <div class="section-title">Definition of Politically Exposed Person (PEP)</div>

      <div class="pep-definition">
        <ol>
          <li>Foreign PEPs, individuals who are or have been entrusted with prominent public functions by a foreign country, for example Heads of State or of government, senior politicians, senior government, judicial or military officials, senior executives of state owned corporations, important political party officials;</li>
          <li>Domestic PEPs, individuals who are or have been entrusted domestically with prominent public functions, for example Heads of State or of government, senior politicians, senior government, judicial or military officials, senior executives of state owned corporations, important political party officials;</li>
          <li>Persons who are or have been entrusted with a prominent function by an international organization, means members of senior management and members of the board or equivalent functions;</li>
          <li>Provided that middle ranking or more junior individuals in the above referred categories are not included in the definition of PEPs.</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        item: {
          BP_ID: null,
          BP_DSC: "",
          BP_ADDRESS: "",
          BRANCH_ID: null,
          C_CODE: null,
          PVN_ID: null,
          CTY_ID: null,
          BP_ACTIVE: false,
          BP_MOBILE: "",
          BP_GST_NO: "",
          BP_NIC_NO: "",
          BP_NTN_NO: "",
          BP_FATHER_HUSBANDNAME: "",
          BP_MOTHERNAME: "",
          BP_ISACTTAXPAY: "",
          BP_UAN: "",
          LANDLINE: "",
          BP_EMAIL_ADDRESS: "",
          BP_DOB: "",
          BP_PLACEOFBIRTH: "",
          BP_ISRESEDENT: "",
          BP_PASSPORTNO: "",
          BP_CNICVARIFICATINO: "",
          BP_CNICISSUEDATE: "",
          BP_CNIC_EXPIRYDATE: "",
          BP_BUSINESSNAME: "",
          BP_BUSINESSADDRESS: "",
          BP_MAINGAOAWITHINPAK: "",
          BP_OUTSIDEPAKACTIVITY: "",
          BP_PEP: "",
          BP_IFPEPYESSELF: "",
          BP_IFPEPPOSITIONSTATUS: "",
          BP_DOMESTICPEP: "",
          BP_IFPEPBYWAOFACC_RELATION: "",
          BP_POSITIONHELD: "",
          BP_SOURCEOFINCOME: "",
          BP_SOURCEOFINCOME_SPFY: ""
        },
        logo: "/Images/uic.png",
      }
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        const url = new URLSearchParams(window.location.search);
        const id = url.get("id");
        axios.get(`/api/UICApi/IndividualClientPrint?ID=${id}`)
          .then((res) => {
            if (res.data.IndividualClientPrint) {
              this.item = res.data.IndividualClientPrint;
            } else {
              console.error("No data received from API");
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      },
    },
  };
</script>



<style>

  body {
    font-family: Arial, sans-serif;
    font-size: 11pt;
    line-height: 1.3;
    margin: 0;
    padding: 20px;
    /*background: #f5f5f5;*/
  }

  .container {
    background: white;
    padding: 50px;
    margin: 0 auto;
    max-width: 800px;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

    .header img {
      width: 100px;
      margin-right: 20px;
    }

  .header-text {
    flex: 1;
    text-align: center;
  }

  .title {
    font-size: 20pt;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .subtitle {
    font-size: 14pt;
    margin-bottom: 5px;
  }

  .individual {
    font-style: italic;
    text-align: center;
    margin-bottom: 20px;
  }

  .date-line {
    text-align: right;
    margin-bottom: 20px;
  }

  .customer-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    flex-wrap: wrap;
    gap: 20px;
  }

  .form-section {
    border: 1px solid #000;
    margin-bottom: 20px;
    padding: 20px;
    background: white;
  }

  .section-title {
    text-align: center;
    font-weight: bold;
    margin-bottom: 15px;
    text-decoration: underline;
    font-size: 13pt;
  }

  .form-row {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .form-field {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 200px;
  }

    .form-field label {
      margin-right: 10px;
    }

  .input-line {
    margin-left: 5px;
    border-bottom: 1px solid #000;
    min-width: 150px;
    display: inline-block;
    /*height: 16px;*/
    flex: 1;
  }

  .customer-info .input-line {
    width: 400px;
  }

  .customer-info div:nth-child(2) .input-line {
    width: 50px;
  }

  .checkbox {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #000;
    margin: 0 5px;
    vertical-align: middle;
    background: white;
  }

  .declaration {
    text-align: justify;
    margin-bottom: 10px;
    line-height: 1.4;
  }

  .signature-line {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    flex-wrap: wrap;
    gap: 20px;
  }

  .signature {
    flex: 1;
    min-width: 250px;
    text-align: center;
  }

  .signature-box {
    border-bottom: 1px solid #000;
    height: 40px;
    margin-bottom: 10px;
  }

  .documents ol {
    margin: 10px 0 10px 25px;
    padding: 0;
  }

  .documents li {
    margin-bottom: 8px;
  }

  .pep-definition ol {
    margin: 10px 0 10px 25px;
    padding: 0;
  }

  .pep-definition li {
    margin-bottom: 10px;
    text-align: justify;
  }

  @page {
    size: A4;
    margin: 20px;
  }

  @page :second {
    margin-top: 5in;
  }

  @media print {
    html, body {
      width: 210mm;
      height: 297mm;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/IndividualClientPrint.vue